<template>
  <div class="authentication">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-sm-12">
          <form class="card auth_form">
            <div class="header">
              <img class="logo" src="@/assets/images/logo.svg" alt="">
              <br /><br /><br />
              <h5>Error 404</h5>
              <span>Page not found</span>
            </div>
            <br />
            <div class="body">
              <a href="/" class="btn btn-primary btn-block waves-effect waves-light">
                Ir al inicio
              </a>
            </div>
          </form>
          <div class="copyright text-center">
            &copy;
            {{ year }},
              <span>Powered by
                <a href="http://itenlearning.com/" target="_blank">IteNlearning</a>
              </span>
          </div>
        </div>
        <div class="col-lg-8 col-sm-12">
          <div class="card">
            <img src="@/assets/images/404.svg" alt="404" />
          </div>
        </div>
      </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'forgotpassword',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
